export const TOAST_VARIANTS = {
  default: {
    container: 'bg-white border border-gray-200',
    title: 'text-gray-900',
    body: 'text-gray-600',
    closeButton: 'text-gray-400 hover:text-gray-600 focus:ring-gray-500',
  },
  success: {
    container: 'bg-green-50 border-l-4 border-green-500',
    title: 'text-green-700',
    body: 'text-green-700',
    closeButton: 'text-vi-green hover:text-green-800 focus:ring-vi-green',
  },
  error: {
    container: 'bg-red-50 border border-vi-red/20',
    title: 'text-vi-red',
    body: 'text-red-700',
    closeButton: 'text-vi-red hover:text-red-800 focus:ring-vi-red',
  },
} as const
